<template>
    <div class="card w-50 mr-5" style="width: 235px!important; max-height: 222px; min-height: 175px;">
        <div class="row">
            <div class="col-12">
                <div class="container-fluid text-center d-flex flex-column">
                    <div class="d-flex flex-column" v-if="!hasImage">
                        <div class="container-fluid course-image p-2" v-on:click="uploadImage" data-toggle="tooltip" data-placement="top" title="Click to upload image">
                            <i class="fa fa-5x fa-image ml-auto mr-auto mt-3"></i>
                            <div v-show="editEnabled && !hasImage">
                                <h5>
                                    Click to choose an image
                                </h5>
                            </div>
                        </div>
                    </div>
                    <img v-bind:src="course | s3url('image')" class="ml-auto mr-auto mt-2" id="image-preview" style="z-index: 1; position: absolute; left: 0; right: 0 ; top: 0; bottom: 0; background-color: white; max-height: 150px;" v-on:click="uploadImage" />
                    <input class="mt-4" @change="handleFileChange($event, course, 'image')" id="upload-image" type="file" style="display: none; " autocomplete="off" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CourseImageHeader',
        props: ["initialCourse", "edit"],
        data: function () {
            return {
                course: this.initialCourse,
                editEnabled: this.edit,
                hasImage: false,
            };
        },
        computed: {
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            }
        },
        methods: {
            uploadImage() {
                if (this.editEnabled) {
                    $("#upload-image").click();
                }
            },
            handleFileChange(event, target, key) {
                this.$emit("fileChange", event, target, key);
                //update this image src as well
                this.hasImage = true;
            },
        },
        mounted: function () {
            var fileInput = document.getElementById("upload-image");
            var imagePreview = document.getElementById("image-preview");
            if (fileInput && imagePreview) {
                if (fileInput.files.length > 0 || imagePreview.src !== '') {
                    this.hasImage = true;
                }
            }
            else {
                this.hasImage = false;
            }
        },
    }
</script>

<style scoped>
    .title {
        font-size: 40px;
    }

    .course-image:hover {
        cursor: pointer;
    }
</style>
